module.exports = __webpack_public_path__ + "img/lock-reset-icon.svg";